module.exports = __webpack_public_path__ + "0af5d249/img/delete-icon.eb7de062.svg";